import { useEffect, useState } from 'react';

import { localStorage } from 'shared/services/localStorage';

type SessionNoteSettings = {
  useTranscriptLanguage: boolean;
};

const SESSION_NOTE_SETTINGS_KEY = 'session-note-settings';
const DEFAULT_SESSION_NOTE_SETTINGS = {
  useTranscriptLanguage: false,
};

export const useSessionNoteSettings = () => {
  const getSettingsFromLocalStorage = () =>
    localStorage.getItem<SessionNoteSettings>(SESSION_NOTE_SETTINGS_KEY) ??
    DEFAULT_SESSION_NOTE_SETTINGS;

  const [settings, setSettings] = useState<SessionNoteSettings>(
    getSettingsFromLocalStorage
  );

  useEffect(() => {
    localStorage.setItem(SESSION_NOTE_SETTINGS_KEY, settings);
  }, [settings]);

  const setUseTranscriptLanguage = (value: boolean) => {
    setSettings({ ...settings, useTranscriptLanguage: value });
  };

  return {
    settings,
    getSettings: getSettingsFromLocalStorage,
    setUseTranscriptLanguage,
  };
};
